import React, { useContext, useEffect, useState } from 'react';
import { baseUrl } from '../../Constants/constant';
import { authContext } from '../../context/AuthProvider.component';
import useFetch from '../../Customhooks/useFetch';
import { useNavigate } from 'react-router-dom';
import { Image, Loader, Paper, Text, Transition } from '@mantine/core';
import { NotFoundImage } from '../../NotFoundComponent/NotFoundPage.component';

const Login = () => {
  const [token, setToken] = useState<string>('');
  const [opened, setOpened] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const { setAuthData }: any = useContext(authContext);

  const localStorageToken = localStorage.getItem("token");

  useEffect(() => {
    const urlParams = window.location.search;
    if (urlParams) {
      const tokenParam = urlParams.substring(1);
      const decodedToken = tokenParam.replace(/%/g, ' ');
      setToken(decodedToken);
    } else if (localStorageToken) {
      setToken(localStorageToken);
    } else if (!localStorageToken) {
      setHasError(true);
      setErrorMessage("Access denied. Please access through SharePoint.");
    }
  }, []);

  const {
    data: postData,
    loading: postLoading,
    error: postError,
    fetchData: loginPost,
  } = useFetch({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "token": token || localStorageToken
    },
    body: JSON.stringify({
      "token": token ? token : localStorageToken
    }),
  });

  useEffect(() => {
    if (token || localStorageToken) {
      loginPost(`${baseUrl}admin/verify`);
    }
  }, [token, localStorageToken]);

  useEffect(() => {
    if (postData) {
      if (postData.status === 200) {
        setAuthData({ data: postData?.data, token: token, group: postData?.data?.group });
        handleSuccessfulAuth();
      } else if (postData.errors) {
        console.log('Error:', postData.message);
        // Set local error state first
        setHasError(true);
        setErrorMessage(postData.message || "Authentication failed");
      }
    }
  }, [postData]);

  useEffect(() => {
    if (postError) {
      console.log('API Error:', postError);
      setHasError(true);
      setErrorMessage("Failed to connect to authentication service");
    }
  }, [postError]);

  const handleSuccessfulAuth = () => {
    setTimeout(() => {
      setOpened(false);
      setTimeout(() => navigate("/dashboard"), 500);
    }, 600);
  };

  if (hasError) {
    return <NotFoundImage error={errorMessage} />;
  }

  return (
    <Transition mounted={opened} transition="fade-down" enterDelay={10} exitDelay={100}>
      {(transitionStyle) => (
        <Paper
          shadow="md"
          p="xl"
          pos="absolute"
          inset={0}
          bottom="auto"
          style={{
            ...transitionStyle,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            zIndex: 1,
          }}
        >
          <Image
            src="https://www.mainetti.com/wp-content/uploads/2023/03/Logo_Mainetti_ThickerStroke_022323.svg"
            alt="Mainetti LCA Logo"
            style={{ width: "250px" }}
          />
          <Loader color="#404040" size="lg" type="bars" mt="xl" />
          <Text mt="sm" fw={300} style={{ fontSize: "14px" }}>
            Initializing Mainetti LCA... Please hold on.
          </Text>
        </Paper>
      )}
    </Transition>
  );
};

export default Login;